<template>
  <div>
    <pendanaan-desktop v-if="!isMobile" />
    <pendanaan-mobile v-else />
  </div>
</template>
<script>
import PendanaanDesktop from "./Desktop/Pendanaan-Desktop.vue";
import PendanaanMobile from "./Mobile/Pendanaan-Mobile.vue";

export default {
  components: { PendanaanDesktop, PendanaanMobile },
  data() {
    return {};
  },

  computed: {
    isMobile() {
      if (window.innerWidth >= 500) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped></style>
